import { DefaultState, Filters } from 'store/types';

export const SET_EXPORT_JOBS_TABLE_FILTERS = 'SET_EXPORT_JOBS_TABLE_FILTERS';

export type ExportJobsTableFiltersState = DefaultState & {
  contents: Filters;
  exists: boolean;
};

interface SetExportJobsTableFilters {
  type: typeof SET_EXPORT_JOBS_TABLE_FILTERS;
  contents: Filters;
  exists: boolean;
}

export type ExportJobsTableFiltersActionTypes = SetExportJobsTableFilters;
